import request from '../services/request';

export function validateEmail(data) {
  return request({
    url: `/admin/valid/email`,
    method: 'POST',
    data,
  });
}

export function validatePhone(data) {
  return request({
    url: `/admin/valid/phone`,
    method: 'POST',
    data,
  });
}
